import React, { useState, useCallback } from 'react';
import './App.css';
import GradientBackground from './components/GradientBackground';
import InputView from './components/InputView';
import DiscoverView from './components/DiscoverView';
import MyListView from './components/MyListView';

// Compare two searches by their anchor books and selected tags (order-insensitive).
function sameSet(a = [], b = []) {
  if (a.length !== b.length) return false;
  const setB = new Set(b);
  return a.every(x => setB.has(x));
}
const anchorIds = p => (p?.anchorBooks ?? []).map(b => `${b.title}::${b.author}`.toLowerCase());
const tagIds    = p => (p?.vibes ?? []).map(v => v.toLowerCase());

function App() {
  const [view, setView] = useState('input');
  const [searchParams, setSearchParams] = useState(null);
  const [myList, setMyList] = useState([]);
  // Every book surfaced this session ('"Title" by Author'), so the engine never
  // repeats a recommendation across searches. Reset only on a completely new search.
  const [shownBooks, setShownBooks] = useState([]);

  const addShownBooks = useCallback((entries) => {
    setShownBooks(prev => {
      const seen = new Set(prev.map(e => e.toLowerCase()));
      const additions = entries.filter(e => !seen.has(e.toLowerCase()));
      return additions.length ? [...prev, ...additions] : prev;
    });
  }, []);

  function handleSubmit(params) {
    // A "completely new search" = both the anchor books AND the tags changed.
    const prev = searchParams;
    const completelyNew = !prev
      || (!sameSet(anchorIds(prev), anchorIds(params)) && !sameSet(tagIds(prev), tagIds(params)));
    if (completelyNew) setShownBooks([]);
    setSearchParams(params);
    setView('discover');
  }

  return (
    <>
      <GradientBackground />
      <div className={`app${view === 'input' ? ' app--input' : ''}`}>
        {view === 'input' && (
          <InputView
            onSubmit={handleSubmit}
            myList={myList}
            onNavigateToList={() => setView('mylist')}
          />
        )}
        {view === 'discover' && searchParams && (
          <DiscoverView
            searchParams={searchParams}
            myList={myList}
            setMyList={setMyList}
            shownBooks={shownBooks}
            addShownBooks={addShownBooks}
            onNavigateToList={() => setView('mylist')}
            onBackToSearch={() => setView('input')}
          />
        )}
        {view === 'mylist' && (
          <MyListView
            myList={myList}
            setMyList={setMyList}
            onBack={() => setView('discover')}
            onDiscover={() => setView('discover')}
          />
        )}
      </div>
    </>
  );
}


export default App;
